// @ts-nocheck
/* eslint-disable */
import * as registry from '../../registry.js'
/**
* @param {{ name: NonNullable<unknown> }} i
*/
export const guestList_deleteGuestConfirm = (i) => `Do you really want to remove "${i.name}"?`